import React, { FC } from 'react';

const iconMapMark = require('./icon_map_mark.svg');

export const IconMapMark: FC = () => {
  return <img src={iconMapMark} width={46} height={57} alt="icon_map_mark" />;
};

IconMapMark.displayName = 'IconMapMark';
